export const FILTER_BUTTON_DRIVER_INSTRUCTION = ['Letztes Jahr', 'Aktuelles Jahr', 'Kein Datum'];

export const DRIVER_LICENSE_CONTROL_FILTER_VALUES = {
  isBooked: { available: 'ja', notAvailable: 'nein' }
};
